import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";

const AdminAutoComplete = (props) => {
  const [searchInput, setSearchInput] = useState("");
  const [displayedList, setDisplayedList] = useState([]);

  useEffect(() => {
    setDisplayedList(props.options);
  }, [props.options]);

  useEffect(() => {
    if (props.options) {
      setDisplayedList(props.options.filter((item) => item.title.toLowerCase().includes(searchInput)));
    }
  }, [searchInput]);

  return (
    <div className="relative z-index10">
      <div className="inline-block relative width100 flex">
        <TextField label={props.autocompletePlaceholder} variant="standard" fullWidth onChange={(e) => setSearchInput(e.target.value)} />
      </div>
      <div className="nice-scroller mt-20">
        {displayedList?.map((curData, i) => {
          return (
            <div className="flex justify-between" key={i}>
              <div
                className={`custom-autocomplete-opt-con${
                  props.selectedOptions?.find((selectedOption) => selectedOption.courseId === curData._id) ? " primary-color bold" : ""
                }`}
                onClick={() => handleListChange(curData._id)}
              >
                {curData.title}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  function handleListChange(item) {
    if (!props.onChange) return;

    let newList = [...props.selectedOptions];

    if (props.selectedOptions.find((option) => option.courseId === item)) {
      newList = newList.filter((option) => option.courseId !== item);
    } else {
      newList.push({ courseId: item, title: props.options.find((option) => option._id === item).title, expiry: new Date() });
    }
    props.onChange(newList);
  }
};

export default AdminAutoComplete;
